import axios from "axios";
import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";

//export default function Lancamento({setOpenModal = false, lancamentoInfo = undefined}){
export default function Lancamento(){
    const location = useLocation();
    const { lancamentoInfo } = location.state || { lancamentoInfo: undefined };

    const dadosStorage = sessionStorage.getItem('lancamento');
    //const dadosStorage = localStorage.getItem('lancamento'); --- IGNORE ---
    const lancamento = JSON.parse(dadosStorage);
    const [origem, setOrigem] = useState('E');
    // console.log(lancamento);
    // console.log(lancamentoInfo);

    const uuid = location.pathname.split('/')[2];

    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [errorMessage, setErrorMessage] = useState('');
    
    const [file, setFile] = useState(null);
    const [PdfFile, setPdfFile] = useState({
            NomePdf: '',
            Arquivo: ''
        });
    const [uploadStatus, setUploadStatus] = useState('');
    //const [lancamentos, setLancamentos] = useState([]);

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const [campos, setCampos] = useState({
        IdLancamento: 0,
        IdPrestacaoDeContas: 0,
        lanDescricao: '',
        lanTipo: '', // 'Receita' ou 'Despesa'
        lanValor: 0,
        lanData: customFormatSmallDate,
        lanDocumento: '',
        lanObservacoes: '',
        lanStatus: 1,
        lanCriadoPor: sessionStorage.nomeUsuario,
        lanCriadoEm: customFormatDate,
        lanAlteradoPor: sessionStorage.nomeUsuario,
        lanAlteradoEm: customFormatDate,
        lanCodigoGUID: ''
    });

    // console.log(campos);
    // console.log(lancamentoInfo);

    useEffect(() => {
        if (lancamentoInfo === undefined){
            setOrigem('N');
            campos.IdLancamento = lancamento.IdLancamento;
            campos.IdPrestacaoDeContas = lancamento.IdPrestacaoDeContas;
            campos.lanDescricao = lancamento.lanDescricao;
            campos.lanTipo = lancamento.lanTipo;
            campos.lanValor = lancamento.lanValor;
            campos.lanData = lancamento.lanData;
            campos.lanDocumento = lancamento.lanDocumento;
            campos.lanObservacoes = lancamento.lanObservacoes;
            campos.lanStatus = lancamento.lanStatus;
            campos.lanCriadoPor = sessionStorage.nomeUsuario;
            campos.lanCriadoEm = customFormatDate;
            campos.lanAlteradoPor = sessionStorage.nomeUsuario;
            campos.lanAlteradoEm = customFormatDate;
            campos.lanCodigoGUID = lancamento.lanCodigoGUID;

            lancamentoInfo = campos;
        }
        else {
            setOrigem('E');
            
            campos.IdLancamento = lancamentoInfo.IdLancamento;
            campos.IdPrestacaoDeContas = lancamentoInfo.IdPrestacaoDeContas;
            campos.lanDescricao = lancamentoInfo.lanDescricao;
            campos.lanTipo = lancamentoInfo.lanTipo;
            campos.lanValor = lancamentoInfo.lanValor;
            campos.lanData = lancamentoInfo.lanData;
            campos.lanDocumento = lancamentoInfo.lanDocumento;
            campos.lanObservacoes = lancamentoInfo.lanObservacoes;
            campos.lanStatus = lancamentoInfo.lanStatus;
            campos.lanCriadoPor = lancamentoInfo.lanCriadoPor;
            campos.lanCriadoEm = lancamentoInfo.lanCriadoEm;
            campos.lanAlteradoPor = sessionStorage.nomeUsuario;
            campos.lanAlteradoEm = customFormatDate;
            campos.lanCodigoGUID = lancamentoInfo.lanCodigoGUID;
        }
    },'')


    // if (modal) {
    //     document.body.classList.add('active-modal')
    // } else {
    //     document.body.classList.remove('active-modal')
    // }

    if (lancamentoInfo !== undefined) {
        preencherCampos();
    }

    function preencherCampos()
    {
        campos.IdLancamento = lancamentoInfo.IdLancamento;
        campos.IdPrestacaoDeContas = lancamentoInfo.IdPrestacaoDeContas;
        campos.lanDescricao = lancamentoInfo.lanDescricao;
        campos.lanTipo = lancamentoInfo.lanTipo;
        campos.lanValor = lancamentoInfo.lanValor;
        campos.lanData = lancamentoInfo.lanData;
        campos.lanDocumento = lancamentoInfo.lanDocumento;
        campos.lanObservacoes = lancamentoInfo.lanObservacoes;
        campos.lanStatus = lancamentoInfo.lanStatus;
        campos.lanCriadoPor = lancamentoInfo.lanCriadoPor;
        campos.lanCriadoEm = lancamentoInfo.lanCriadoEm;
        campos.lanAlteradoPor = sessionStorage.nomeUsuario;
        campos.lanAlteradoEm = customFormatDate;
        campos.lanCodigoGUID = lancamentoInfo.lanCodigoGUID;
    }

    function handleInputChange(event) {
        if(event.target.name === 'lanValor') {
            const rawValue = event.target.value;
            const numericValue = rawValue.replace(/[^0-9,.]/g, '').replace(',', '.'); 
            event.target.value = numericValue;
        }

        campos[event.target.name] = event.target.value;
        if (lancamentoInfo){
            lancamentoInfo[event.target.name] = event.target.value;
        }
    };

    var bloqueio = false;
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    function handleFecharModal(){
        if(campos.IdLancamento > 0){
            console.log('aqui-1');
            // setOpenModal(false);
            window.history.back();
        }
        else {   
            //window.location.href = '/Associado';
            console.log('aqui-2'); 
            window.history.back();
        }
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        
        if (!campos.lanDescricao || campos.lanDescricao.trim() === '' 
        || parseFloat(campos.lanValor) <= 0 || !campos.lanData 
        || campos.lanData.trim() === '') {
            setErrorMessage('Preencha todos os campos obrigatórios.');
            bloqueio = true;
            return;
        } else {
            setErrorMessage('');
            bloqueio = false;
        }

        if (bloqueio === false) {
            bloqueio = true;
            if(file) {
                const formData = new FormData();
                formData.append('pdfFile', file);
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (fileLoadedEvent) {
                var srcData = fileLoadedEvent.target.result;
                PdfFile['arquivo'] = srcData.split(',')[1];
                PdfFile['NomePDF'] = uuid + '_' + file.name;
                setPdfFile(PdfFile);
                }

                axios
                .post(process.env.REACT_APP_API_URL + 
                    '/routes.php?metodo=uploadDocumentoLancamento', formData
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "multipart/form-data; charset=UTF-8"
                } })
                .then(response => {
                    campos.lanDocumento = response.data['filePath'];
                    if (lancamentoInfo){
                        lancamentoInfo.lanDocumento = response.data['filePath'];
                    }
                    setUploadStatus(`Sucesso: ${response.data.message}`);
                    bloqueio = false;
                    salvarLancamento();
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    setUploadStatus(`Erro ao enviar: ${error.response ? error.response.data.message : error.message}`);
                    bloqueio = false;
                    return;
                });
            } else {
                bloqueio = false;
                salvarLancamento();
            }
        }
    }

    function salvarLancamento() {
        if (bloqueio === false) {
            if (campos.IdLancamento > 0) {
                //console.log('Atualizando lançamento existente com ID:', campos.IdLancamento);
                //console.log(campos);
                axios
                .post(process.env.REACT_APP_API_URL +
                `/routes.php?metodo=atualizarLancamento`, campos
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } }
                )
                .then(response => {
                    //console.log(response.data);
                    bloqueio = false;
                    alert('Lançamento atualizado com sucesso!');
                    window.location.href = '/#/Lancamentos/' + campos.IdPrestacaoDeContas; // Redireciona
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao atualizar o lançamento. Por favor, tente novamente.');
                });
            }
            else {
                //console.log('Criando novo lançamento');
                //console.log(campos);
                axios.post(process.env.REACT_APP_API_URL +
                `/routes.php?metodo=novoLancamento`, campos
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } }
                )
                .then(response => {
                    //console.log(response.data);
                    bloqueio = false;
                    alert('Lançamento realizado com sucesso!');
                    window.location.href = '/#/Lancamentos/' + campos.IdPrestacaoDeContas; // Redireciona
                })
                .catch(error => {
                    console.error('Houve um erro ao ennviar o formulario:', error);
                    bloqueio = false;
                    alert('Houve um erro ao realizar o lançamento. Por favor, tente novamente.');
                });
            }
        }
    }

    return (
        <>
            <main>
                <div>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-left w80 fs16'>
                            <button
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>
                    {/* form */}
                    <form onSubmit={handleFormSubmit}>
                        <div className='headerMain'>
                            <label className='labelTitulo' >LANÇAMENTO</label>
                        </div>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4"> 

                            {/* Descrição */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>DESCRIÇÃO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                        defaultValue={campos.lanDescricao}
                                            onChange={handleInputChange}
                                        className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                        required
                                        name="lanDescricao"
                                        id="lanDescricao"
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            {/* Lançamento */}
                            <div className="d-flex flex-row divForm">
                                {/* Data lancamento */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>DATA</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                        type="date"
                                        format="DD/MM/YYYY"
                                        defaultValue={campos.lanData}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 fs12 w100 text-align-center" 
                                        required
                                        name="lanData"
                                        id="lanData"
                                        />
                                    </div>
                                </div>
                                {/* Tipo */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>TIPO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <select
                                        defaultValue={campos.lanTipo}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 fs12 w100 text-align-center" 
                                        required
                                        name="lanTipo"
                                        id="lanTipo"
                                        >
                                            <option value="Receita">Receita</option>
                                            <option value="Despesa">Despesa</option>
                                        </select>
                                    </div>
                                </div>
                                {/* Valor */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs16'>
                                        <label>VALOR</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs1'>
                                        <input
                                        defaultValue={campos.lanValor}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 p1 fs12 w100 text-align-right" 
                                        required
                                        name="lanValor"
                                        id="lanValor"
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            {/* Observações */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>OBSERVAÇÕES</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs1'>
                                        <textarea
                                        defaultValue={campos.lanObservacoes}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                        required
                                        name="lanObservacoes"
                                        id="lanObservacoes"
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            { /* upload documento */}
                            <div className="d-flex flex-column divForm">
                                <div className='text-align-left w100 divForm fs16'>
                                    <label>DOCUMENTO</label>
                                </div>
                                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                <div className='text-align-center divForm w100 fs12'>
                                    <input
                                    type="file"
                                    name="lanDocumento"
                                    className="p1 bgGray fs12 w100"
                                    id="lanDocumento"
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={handleFileChange}/>
                                    <p>{uploadStatus}</p>
                                </div> ) : ('') } 
                                <div className='text-align-left divForm w100 fs10'>
                                    <label>{campos.lanDocumento.replace('uploads/lancamentos/','')}</label>
                                </div>
                            </div>
                            
                            {/* ALERTAS AVISOS */}
                            {errorMessage !== null && errorMessage !== '' ? (
                                <div className='text-align-left divForm fs10'>
                                    <span className="AlertPassword">
                                        {errorMessage}
                                    </span>
                                </div>
                            ) : (
                                <div></div>
                            )}
                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                <button 
                                    className='buttonModalPadrao pt1 pb1 w100 fs14'
                                    type="submit">
                                        SALVAR LANÇAMENTO
                                </button> ) : ('') } 
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    )
}

